import { useLocalSearchParams, useRouter } from "expo-router";
import { useEffect } from "react";

export default function Index() {
  const rest = useLocalSearchParams();
  const router = useRouter();

  useEffect(() => {
    router.replace({
      pathname: `/orgs`,
      params: rest,
    });
  }, []);

  return null;
}
